import { filter } from 'rxjs/operators';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ActivatedRoute } from '@angular/router';
import { create } from 'd3-selection';
import { RepositoryService } from 'src/app/services/repository.service';
import { param } from 'jquery';

@Component({
  selector: 'app-podrobno',
  templateUrl: './podrobno.component.html',
  styleUrls: ['./podrobno.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class PodrobnoComponent implements OnInit {

  public returnedQueryParams = [];
  public dataSourceLicences = new MatTableDataSource <Array<any>>();
  //na childs in parents sem ločil, ker WS vrača tako, da se nekje podvajajo informacije npr. code, servercode ... zdaj pa tu bom te združil in tiste stvari, ki se razlikujejo dal v child (to pa so datacodei n datavalue)
  public dataSourceLicencesParents = new MatTableDataSource <any>();
  public dataSourceLicencesParentsFirstHalf = new MatTableDataSource <any>();
  public dataSourceLicencesParentsSecondHalf = new MatTableDataSource <any>();
  public dataSourceLicencesChilds: Array<any> = [];
  public dataSourceLicencesChildsFirstHalf: Array<any> = [];
  public dataSourceLicencesChildsSecondHalf: Array<any> = [];
  public dataSourceLicencesChildsUNCHANGED: Array<any> = [];
  public columnsLicencesParents = [];
  public columnsLicencesChild = ['dataCode', 'dataValue'];
  public expandedElement;
  public spinner = true;
  public filterText;
  public partnerCodeFilter = new UntypedFormControl('');
  public codeFilter = new UntypedFormControl('');
  public licenceCodeFilter = new UntypedFormControl('');
  public partnerTitleSmallFilter = new UntypedFormControl('');
  public ipFilter = new UntypedFormControl('');
  public licenceNameSmallFilter = new UntypedFormControl('');
  public filterValues = {
    partnerCode: '',
    code: '',
    licenceCode: '',
    partnerTitleSmall: '',
    ip: '',
    licenceNameSmall: '',
 };
 public toggleFilter;
 public childIndex;
  //modulId: module.modulId, modulNameSmall: module.modulNameSmall, serverCode: module.serverCode, companyId: selectedCompanies?.id
  constructor(private repositoryService: RepositoryService, private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      this.returnedQueryParams.push(params['modulNameSmall']);
      this.returnedQueryParams.push(params['serverCode']);
      this.returnedQueryParams.push(params['modulId']);
      this.returnedQueryParams.push(params['companyId']);
  });

  }

  ngOnInit() {
    //modul, serverCode, modulId, companyId
    
  console.log(this.returnedQueryParams);
    this.repositoryService.getLicenses(this.returnedQueryParams[0], this.returnedQueryParams[1],
      this.returnedQueryParams[2], this.returnedQueryParams[3]).subscribe( data => {
        
      this.dataSourceLicences = new MatTableDataSource(data.data.pointOfSale);

    this.createParentLicences(this.dataSourceLicences.data);
    this.dataSourceLicencesParents.filterPredicate = this.createFilter();
    this.dataSourceLicencesParentsFirstHalf.filterPredicate = this.createFilter();
    this.dataSourceLicencesParentsSecondHalf.filterPredicate = this.createFilter();
    this.spinner = false;
    }, error => {
      console.log(error);
    });
    this.filterSubscriptions();

    this.repositoryService.currentluminaPOSFilterToggle.subscribe( data => {
      this.toggleFilter = data;
    });
  }


  filterSubscriptions() {
    this.partnerCodeFilter.valueChanges
    .subscribe(
      partnerCode => {
        this.filterValues.partnerCode = partnerCode;
        this.dataSourceLicencesParents.filter = JSON.stringify(this.filterValues);
        this.dataSourceLicencesParentsFirstHalf.filter = JSON.stringify(this.filterValues);
        this.dataSourceLicencesParentsSecondHalf.filter = JSON.stringify(this.filterValues);
        this.filterChildArray();
      }
    )
  this.codeFilter.valueChanges
    .subscribe(
      code => {
        this.filterValues.code = code;
        this.dataSourceLicencesParents.filter = JSON.stringify(this.filterValues);
        this.dataSourceLicencesParentsFirstHalf.filter = JSON.stringify(this.filterValues);
        this.dataSourceLicencesParentsSecondHalf.filter = JSON.stringify(this.filterValues);
        this.filterChildArray();
      }
    )
  this.licenceCodeFilter.valueChanges
    .subscribe(
      licenceCode => {
        this.filterValues.licenceCode = licenceCode;
        this.dataSourceLicencesParents.filter = JSON.stringify(this.filterValues);
        this.dataSourceLicencesParentsFirstHalf.filter = JSON.stringify(this.filterValues);
        this.dataSourceLicencesParentsSecondHalf.filter = JSON.stringify(this.filterValues);
        this.filterChildArray();
      }
    )
    this.partnerTitleSmallFilter.valueChanges
    .subscribe(
      partnerTitleSmall => {
        this.filterValues.partnerTitleSmall = partnerTitleSmall;
        this.dataSourceLicencesParents.filter = JSON.stringify(this.filterValues);
        this.dataSourceLicencesParentsFirstHalf.filter = JSON.stringify(this.filterValues);
        this.dataSourceLicencesParentsSecondHalf.filter = JSON.stringify(this.filterValues);
        this.filterChildArray();
      }
    )
    this.ipFilter.valueChanges
    .subscribe(
      ip => {
        this.filterValues.ip = ip;
        this.dataSourceLicencesParents.filter = JSON.stringify(this.filterValues);
        this.dataSourceLicencesParentsFirstHalf.filter = JSON.stringify(this.filterValues);
        this.dataSourceLicencesParentsSecondHalf.filter = JSON.stringify(this.filterValues);
        this.filterChildArray();
      }
    )
    this.licenceNameSmallFilter.valueChanges
    .subscribe(
      licenceNameSmall => {
        this.filterValues.licenceNameSmall = licenceNameSmall;
        this.dataSourceLicencesParents.filter = JSON.stringify(this.filterValues);
        this.dataSourceLicencesParentsFirstHalf.filter = JSON.stringify(this.filterValues);
        this.dataSourceLicencesParentsSecondHalf.filter = JSON.stringify(this.filterValues);
        this.filterChildArray();
      }
    )
  }

  filterChildArray() {
    this.dataSourceLicencesChilds = this.dataSourceLicencesChildsUNCHANGED;
    this.dataSourceLicencesChildsFirstHalf = this.dataSourceLicencesChildsUNCHANGED;
    this.dataSourceLicencesChildsSecondHalf = this.dataSourceLicencesChildsUNCHANGED;
    let filteredArray = [];
    for(let i = 0; i < this.dataSourceLicencesParents.filteredData.length; i++) {
      let index = this.dataSourceLicencesParents.data.findIndex(element => element.code === this.dataSourceLicencesParents.filteredData[i].code &&
        element.partnerCode === this.dataSourceLicencesParents.filteredData[i].partnerCode);
      filteredArray.push(this.dataSourceLicencesChilds[index]);
    }
    this.dataSourceLicencesChilds = filteredArray;
    this.splitToTwoTables();
  }

  //code ip licenceNamesmall partnercode partnerTitleSmall
  createParentLicences(data) {
    this.dataSourceLicencesParents.data = [];
    this.dataSourceLicencesChilds = [];
    this.columnsLicencesParents = [];
    let arrayOfChilds: Array<any> = [];
    for(let i = 0; i < data.length; i++) {
      if (this.dataSourceLicencesParents.data.some(element => element.code === data[i].code && element.partnerCode === data[i].partnerCode)) {
        let index = this.dataSourceLicencesParents.data.findIndex(element => element.code === data[i].code && element.partnerCode === data[i].partnerCode);
        arrayOfChilds[index]
        .push({dataCode: data[i].dataCode, dataValue: data[i].dataValue});
      } else {
        arrayOfChilds.length = this.dataSourceLicencesParents.data.length;
        arrayOfChilds[this.dataSourceLicencesParents.data.length] = [];
        if(data[i].dataCode != null && data[i].dataValue != null) {
          arrayOfChilds[this.dataSourceLicencesParents.data.length].push({dataCode: data[i].dataCode, dataValue: data[i].dataValue});
        }
        delete data[i]['dataCode'];
        delete data[i]['dataValue'];
        this.dataSourceLicencesParents.data.push(data[i]);
      }
    }

    if(this.dataSourceLicencesParents.data.length > 0) {
      Object.keys(this.dataSourceLicencesParents.data[0]).forEach(key => {
        this.columnsLicencesParents.push(key);
      });
      this.columnsLicencesParents.push('uredi');
    }

    this.dataSourceLicencesChilds = arrayOfChilds;
    this.dataSourceLicencesChildsUNCHANGED = arrayOfChilds;
    this.splitToTwoTables();

  }

  splitToTwoTables() {
    let splitIndex = this.dataSourceLicencesChilds.length/2;
    var firstHalfChild = this.dataSourceLicencesChilds.slice(0, splitIndex);
    var secondHalfChild = this.dataSourceLicencesChilds.slice(splitIndex);
    this.dataSourceLicencesChildsFirstHalf = firstHalfChild;
    this.dataSourceLicencesChildsSecondHalf = secondHalfChild;
    var firstHalfParents = this.dataSourceLicencesParents.data.slice(0, splitIndex);
    var secondHalfParents = this.dataSourceLicencesParents.data.slice(splitIndex);
    this.dataSourceLicencesParentsFirstHalf.data = firstHalfParents;
    this.dataSourceLicencesParentsSecondHalf.data = secondHalfParents;

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceLicencesParents.filter = filterValue.trim().toLowerCase();
  }

  //naredi filter za dataSource Parent
  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function(data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return (data.partnerCode || '').toLowerCase().indexOf(searchTerms.partnerCode.toLowerCase()) !== -1
        && (data.code || '').toString().toLowerCase().indexOf(searchTerms.code.toLowerCase()) !== -1
        && (data.partnerTitleSmall || '').toString().toLowerCase().indexOf(searchTerms.partnerTitleSmall.toLowerCase()) !== -1
        && (data.ip || '').toString().toLowerCase().indexOf(searchTerms.ip.toLowerCase()) !== -1
        && (data.licenceNameSmall || '').toString().toLowerCase().indexOf(searchTerms.licenceNameSmall.toLowerCase()) !== -1
        && (data.licenceCode || '').toLowerCase().indexOf(searchTerms.licenceCode.toLowerCase()) !== -1;
    }
    return filterFunction;
  }

  onPonastavi() {
    this.partnerCodeFilter.setValue("");
    this.partnerTitleSmallFilter.setValue("");
    this.codeFilter.setValue("");
    this.ipFilter.setValue("");
    this.licenceCodeFilter.setValue("");
    this.licenceNameSmallFilter.setValue("");
  }
}
